import { SEGMENT_FROM, SEGMENT_TO } from '@/constants';

export const DUPLICATE_SEGMENT_ERROR = 'Segment already exists.';

// Segment Menu defaults
export const SEGMENT_FROM_DEFAULT = SEGMENT_FROM.MP;
export const SEGMENT_TO_DEFAULT = SEGMENT_TO.MD;
